// This file is generated by scripts/generate_session_filter_ai_query_vocabulary.py.
// Do not edit it by hand.

export type SessionFilterCoreVocabularyTerm = {
  readonly name: string;
  readonly type: string;
  readonly description: string;
  readonly category: string;
  readonly iterableName: string | null;
};

// oxfmt-ignore
export const sessionFilterCoreVocabulary: SessionFilterCoreVocabularyTerm[] = [
  {
    name: "session_id",
    type: "string",
    description: "Session identifier string. `in` containment ignores case, `==` matches exactly.",
    category: "session",
    iterableName: null,
  },
  {
    name: "first_input",
    type: "string",
    description: "The input.value string of the session's earliest root span, ordered by trace start time, then trace id, then span id. `in` containment ignores case, `==` is exact; a session with no such value is SQL null, so `not in` and comparisons exclude it (target it with `is None`). To search every root span rather than the earliest one, use the cheaper any_input.",
    category: "session",
    iterableName: null,
  },
  {
    name: "last_output",
    type: "string",
    description: "The output.value string of the session's latest root span, ordered by trace start time, then trace id, then span id, descending. `in` containment ignores case, `==` is exact; a session with no such value is SQL null, so `not in last_output` excludes it (target it with `is None`). To search every root span rather than the latest one, use the cheaper any_output.",
    category: "session",
    iterableName: null,
  },
  {
    name: "start_time",
    type: "datetime",
    description: "Session start timestamp (earliest trace) \u2014 a point comparison against the session's own bound, unlike the view's time range, which selects sessions that overlap a window. Compare against ISO 8601 strings, e.g. start_time > '2026-07-01T00:00:00+00:00'; values without a timezone are read as UTC, so prefer an offset-bearing literal.",
    category: "session",
    iterableName: null,
  },
  {
    name: "end_time",
    type: "datetime",
    description: "Session end timestamp (latest trace) \u2014 a point comparison against the session's own bound, unlike the view's time range, which selects sessions that overlap a window. Compare against ISO 8601 strings, e.g. end_time < '2026-07-04T12:00:00+00:00'; values without a timezone are read as UTC, so prefer an offset-bearing literal.",
    category: "session",
    iterableName: null,
  },
  {
    name: "duration_ms",
    type: "number",
    description: "Session wall-clock duration in milliseconds (end_time - start_time).",
    category: "session",
    iterableName: null,
  },
  {
    name: "completion_cost",
    type: "number",
    description: "Total completion cost across the session's spans; 0 when no cost is configured, never null.",
    category: "aggregate",
    iterableName: null,
  },
  {
    name: "llm_span_count",
    type: "number",
    description: "Number of LLM spans in the session; 0 when absent, never null.",
    category: "aggregate",
    iterableName: null,
  },
  {
    name: "num_traces",
    type: "number",
    description: "Number of traces in the session; 0 when absent, never null. Instrumentation that starts one trace per exchange makes this an approximate conversation-turn count, but Phoenix does not enforce that shape.",
    category: "aggregate",
    iterableName: null,
  },
  {
    name: "num_traces_with_error",
    type: "number",
    description: "Number of traces in the session containing an errored span; 0 when absent, never null.",
    category: "aggregate",
    iterableName: null,
  },
  {
    name: "prompt_cost",
    type: "number",
    description: "Total prompt cost across the session's spans; 0 when no cost is configured, never null.",
    category: "aggregate",
    iterableName: null,
  },
  {
    name: "token_count_completion",
    type: "number",
    description: "Total LLM completion tokens across the session's spans; 0 when absent, never null.",
    category: "aggregate",
    iterableName: null,
  },
  {
    name: "token_count_prompt",
    type: "number",
    description: "Total LLM prompt tokens across the session's spans; 0 when absent, never null.",
    category: "aggregate",
    iterableName: null,
  },
  {
    name: "token_count_total",
    type: "number",
    description: "Total LLM tokens (prompt + completion) across the session's spans; 0 when absent, never null.",
    category: "aggregate",
    iterableName: null,
  },
  {
    name: "tool_span_count",
    type: "number",
    description: "Number of TOOL spans in the session; 0 when absent, never null.",
    category: "aggregate",
    iterableName: null,
  },
  {
    name: "total_cost",
    type: "number",
    description: "Total cost across the session's spans; 0 when no cost is configured, never null.",
    category: "aggregate",
    iterableName: null,
  },
  {
    name: "any_input",
    type: "containment",
    description: "Whether ANY root span in the session has an input.value containing the given text, ignoring case \u2014 an existential test over root spans, not a value. Containment only: write `'x' in any_input`, never `any_input == 'x'`. `'x' not in any_input` also matches sessions with no root-span input at all. Payloads are instrumentation-shaped, not user-role messages.",
    category: "session",
    iterableName: null,
  },
  {
    name: "any_output",
    type: "containment",
    description: "Whether ANY root span in the session has an output.value containing the given text, ignoring case \u2014 an existential test over root spans, not a value. Containment only: write `'x' in any_output`, never `any_output == 'x'`. `'x' not in any_output` also matches sessions with no root-span output at all. Payloads are instrumentation-shaped, not agent-role messages.",
    category: "session",
    iterableName: null,
  },
  {
    name: "attributes[...]",
    type: "string",
    description: "Root-span attribute access by OTel wire key: string subscripts are joined with dots, so attributes[\"llm.model_name\"] and attributes[\"llm\"][\"model_name\"] name the same key and match it however ingestion nested it (the fully dot-split shape wins if several coexist). Numeric subscripts address the stored JSON literally. Values are read from the session's earliest root span and are string-cast unless explicitly cast. `in` containment ignores case, `==` matches exactly. A missing key is SQL null, so comparisons and `not in` exclude those sessions (target them with `is None`).",
    category: "attribute",
    iterableName: null,
  },
  {
    name: "user.id",
    type: "string",
    description: "Accepted proxy for attributes[\"user.id\"]; reads from the session's earliest root span. Missing on that span is SQL null (target it with `is None`).",
    category: "attribute",
    iterableName: null,
  },
  {
    name: "metadata[\"key\"]",
    type: "string",
    description: "Accepted proxy for attributes[\"metadata.key\"]; reads from the session's earliest root span. Missing on that span is SQL null (target it with `is None`).",
    category: "attribute",
    iterableName: null,
  },
  {
    name: "session_annotations",
    type: "iterable",
    description: "Annotations attached to the session itself, e.g. any(annotation.name == \"Quality\" and annotation.score > 0.8 for annotation in session_annotations).",
    category: "iterable",
    iterableName: null,
  },
  {
    name: "label",
    type: "string",
    description: "Annotation label; null when the annotation has none.",
    category: "element",
    iterableName: "session_annotations",
  },
  {
    name: "name",
    type: "string",
    description: "Annotation name.",
    category: "element",
    iterableName: "session_annotations",
  },
  {
    name: "score",
    type: "number",
    description: "Annotation score; null when the annotation has none.",
    category: "element",
    iterableName: "session_annotations",
  },
  {
    name: "span_annotations",
    type: "iterable",
    description: "Every annotation on any span in the session, flattened to session scope, e.g. any(annotation.label == \"hallucinated\" for annotation in span_annotations).",
    category: "iterable",
    iterableName: null,
  },
  {
    name: "label",
    type: "string",
    description: "Annotation label; null when the annotation has none.",
    category: "element",
    iterableName: "span_annotations",
  },
  {
    name: "name",
    type: "string",
    description: "Annotation name.",
    category: "element",
    iterableName: "span_annotations",
  },
  {
    name: "score",
    type: "number",
    description: "Annotation score; null when the annotation has none.",
    category: "element",
    iterableName: "span_annotations",
  },
  {
    name: "span_cost_details",
    type: "iterable",
    description: "The per-token-type cost rows of every span in the session, flattened to session scope (not rolled up per session), e.g. sum(cost_detail.tokens for cost_detail in span_cost_details if cost_detail.token_type == \"cache_read\").",
    category: "iterable",
    iterableName: null,
  },
  {
    name: "cost",
    type: "number",
    description: "Cost of this row; null when no cost is configured.",
    category: "element",
    iterableName: "span_cost_details",
  },
  {
    name: "cost_per_token",
    type: "number",
    description: "Cost per token for this row; null when unrecorded.",
    category: "element",
    iterableName: "span_cost_details",
  },
  {
    name: "is_prompt",
    type: "boolean",
    description: "Whether this cost row counts toward the prompt side.",
    category: "element",
    iterableName: "span_cost_details",
  },
  {
    name: "token_type",
    type: "string",
    description: "Token type this cost row covers, e.g. input, output, audio.",
    category: "element",
    iterableName: "span_cost_details",
  },
  {
    name: "tokens",
    type: "number",
    description: "Token count for this row; null when unrecorded.",
    category: "element",
    iterableName: "span_cost_details",
  },
  {
    name: "spans",
    type: "iterable",
    description: "Every span in the session. Iterate it with any/all/len/max/min/sum, e.g. any(span.status_code == \"ERROR\" for span in spans).",
    category: "iterable",
    iterableName: null,
  },
  {
    name: "latency_ms",
    type: "number",
    description: "Span duration in milliseconds.",
    category: "element",
    iterableName: "spans",
  },
  {
    name: "llm_token_count_completion",
    type: "number",
    description: "Completion tokens recorded on this span; null on spans that record none.",
    category: "element",
    iterableName: "spans",
  },
  {
    name: "llm_token_count_prompt",
    type: "number",
    description: "Prompt tokens recorded on this span; null on spans that record none.",
    category: "element",
    iterableName: "spans",
  },
  {
    name: "llm_token_count_total",
    type: "number",
    description: "Prompt plus completion tokens recorded on this span; 0 when it records none.",
    category: "element",
    iterableName: "spans",
  },
  {
    name: "name",
    type: "string",
    description: "Span name.",
    category: "element",
    iterableName: "spans",
  },
  {
    name: "span_kind",
    type: "string",
    description: "Span kind, e.g. LLM, TOOL, RETRIEVER; casing is ignored.",
    category: "element",
    iterableName: "spans",
  },
  {
    name: "status_code",
    type: "string",
    description: "Span status: OK, ERROR, or UNSET; casing is ignored.",
    category: "element",
    iterableName: "spans",
  },
  {
    name: "traces",
    type: "iterable",
    description: "The session's traces, ordered by start time. A trace element also iterates its spans, e.g. any(any(span.span_kind == \"TOOL\" for span in trace.spans) for trace in traces). Instrumentation that starts one trace per exchange makes a trace an approximate conversation turn, but Phoenix does not enforce that shape.",
    category: "iterable",
    iterableName: null,
  },
  {
    name: "end_time",
    type: "datetime",
    description: "Trace end timestamp. Compare against ISO 8601 strings.",
    category: "element",
    iterableName: "traces",
  },
  {
    name: "latency_ms",
    type: "number",
    description: "Trace duration in milliseconds.",
    category: "element",
    iterableName: "traces",
  },
  {
    name: "start_time",
    type: "datetime",
    description: "Trace start timestamp. Compare against ISO 8601 strings.",
    category: "element",
    iterableName: "traces",
  },
];
